import React from 'react';
import { Card } from './ui';
import { XCircle } from 'lucide-react';
export function Testimonials() {
  return <section className="py-10 bg-brand-50 border-y border-lav-100" data-id="element-37" data-mp="3mvc1ww16vyf2">
      <div className="max-w-6xl mx-auto px-4" data-id="element-38" data-mp="38wvwd8f2cdyi">
        <div className="flex flex-wrap justify-center gap-6 md:gap-14 text-center mt-[22px] mb-[22px]" data-id="element-39" data-mp="38w3zzvdn6c76">
          <div data-id="element-40" data-mp="3du5j2gb2ibin">
            <p className="text-3xl font-bold text-ink mb-1" data-id="element-41" data-mp="3dxtbtd8outwb">6</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-42" data-mp="2z60x93gpxjvn">
              Tomos completos
            </p>
          </div>
          <div data-id="element-43" data-mp="33zlvmwm84fvd">
            <p className="text-3xl font-bold text-ink mb-1" data-id="element-44" data-mp="2q64hjrcb3vcq">5</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-45" data-mp="2q7z2h5nkvngt">
              Bonos exclusivos
            </p>
          </div>
          <div data-id="element-46" data-mp="2g885mxbjowdk">
            <p className="text-3xl font-bold text-ink mb-1" data-id="element-47" data-mp="2g7eyvwcl66vf">100%</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-48" data-mp="2gaawtkofovjv">
              Digital
            </p>
          </div>
          <div data-id="element-49" data-mp="2mobx6oldr2b9">
            <p className="text-3xl font-bold text-ink mb-1 flex items-center justify-center gap-1" data-id="element-50" data-mp="2mnsjjk2rj031">
              Acceso
            </p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-51" data-mp="2hruyx1kgv7kg">
              Inmediato
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-52" data-mp="2qq701xiylnr5">
          <Card className="bg-white" data-id="element-53" data-mp="2qocc0ace5fiu">
            <div className="flex gap-1 mb-4" data-id="element-54" data-mp="230cpxnq0ydal">
              <span className="text-2xl" aria-hidden="true" data-id="element-55" data-mp="23149g06ckkki">
                🥗
              </span>
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-56" data-mp="1yxfzxby5newm">
              "Cocinás una vez y comés bien toda la semana. El método Batch
              Cooking te ordena la compra, la cocina y el freezer en pocas
              horas."
            </p>
            <div className="flex items-center gap-3" data-id="element-57" data-mp="1k9l61s8ev4hy">
              <div className="w-10 h-10 rounded-full bg-brand-100 flex items-center justify-center text-brand-600 font-bold" data-id="element-58" data-mp="1k80b41i6pjjk">
                1
              </div>
              <div data-id="element-59" data-mp="3fcq9yy3pxpes">
                <p className="font-bold text-ink" data-id="element-60" data-mp="3fd9ixpbe53go">Organizá tu semana</p>
                <p className="text-xs text-slate-500" data-id="element-61" data-mp="3kbba6xiz0938">Tomos 1 a 3</p>
              </div>
            </div>
          </Card>

          <Card className="bg-white" data-id="element-62" data-mp="3p44dri2pdbdq">
            <div className="flex gap-1 mb-4" data-id="element-63" data-mp="3u25wu304pap7">
              <span className="text-2xl" aria-hidden="true" data-id="element-64" data-mp="3u1w6uff333ji">
                🍽️
              </span>
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-65" data-mp="2wgrtjek0lfnl">
              "Desayunos, snacks, almuerzos y cenas fitness con cantidades
              exactas y recetas completas, listas para porcionar y guardar."
            </p>
            <div className="flex items-center gap-3" data-id="element-66" data-mp="3aege0la66ks4">
              <div className="w-10 h-10 rounded-full bg-brand-100 flex items-center justify-center text-brand-600 font-bold" data-id="element-67" data-mp="3afzv2e3ngzuy">
                2
              </div>
              <div data-id="element-68" data-mp="pno73x0eqqhx">
                <p className="font-bold text-ink" data-id="element-69" data-mp="pmwdgrqdf2ua">Recetarios completos</p>
                <p className="text-xs text-slate-500" data-id="element-70" data-mp="2a6rou3apjzqo">Tomos 4 y 5</p>
              </div>
            </div>
          </Card>

          <Card className="bg-white" data-id="element-71" data-mp="265psbu86e1se">
            <div className="flex gap-1 mb-4" data-id="element-72" data-mp="266raeinlzojm">
              <span className="text-2xl" aria-hidden="true" data-id="element-73" data-mp="21d4xcpdj9ina">
                📅
              </span>
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-74" data-mp="1we2565inj6wq">
              "Planificación anual, rotación de heladera y freezer y reset
              semanal para convertir el Meal Prep en un hábito que se sostiene."
            </p>
            <div className="flex items-center gap-3" data-id="element-75" data-mp="1mis17c8p0pgb">
              <div className="w-10 h-10 rounded-full bg-brand-100 flex items-center justify-center text-brand-600 font-bold" data-id="element-76" data-mp="1ieam3qda30bv">
                3
              </div>
              <div data-id="element-77" data-mp="3ct3bh7nkiuvd">
                <p className="font-bold text-ink" data-id="element-78" data-mp="3ctmvctws3tc1">Mantenelo todo el año</p>
                <p className="text-xs text-slate-500" data-id="element-79" data-mp="37u0i4kgyad38">Tomo 6 + 5 Bonos</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}
export function Problem() {
  return <section className="py-12 px-4" data-id="element-80" data-mp="29hxnbglmtnof">
      <div className="max-w-3xl mx-auto" data-id="element-81" data-mp="29gwb38svqv54">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-ink mb-5" data-id="element-82" data-mp="29ftjszrnaqoo">
          ¿CUÁNTAS VECES EMPEZASTE UNA DIETA... Y LA ABANDONASTE POR FALTA DE
          ORGANIZACIÓN?
        </h2>

        <p className="text-slate-300 text-center text-[16px] mt-[11px] mb-[11px]" data-id="element-83" data-mp="20jc7vubgiorv">
          Querés comer saludable. Querés progresar. Querés ahorrar tiempo. Pero
          llega el lunes y otra vez terminás cocinando sobre la marcha,
          comprando cualquier cosa o pidiendo delivery porque no preparaste
          nada.
        </p>

        <p className="text-lg font-bold text-center text-brand-600 mb-6" data-id="element-84" data-mp="1gsqr4o9nha6c">
          No es falta de disciplina. Es falta de un sistema.
        </p>

        <Card className="bg-white border-brand-200 mb-6" data-id="element-85" data-mp="12vu0onxg1upz">
          <ul className="space-y-3" data-id="element-86" data-mp="17rsi1rkcucgw">
            {['Abrís la heladera y no hay ninguna comida lista.', 'Terminás comiendo cualquier cosa porque llegás cansado.', 'Gastás de más comprando comida afuera.', 'Nunca sabés qué cocinar.', 'Cocinás todos los días perdiendo horas.', 'Cada lunes volvés a empezar.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-87" data-mp="t4ttc4cvtw5v" data-mpi={i}>
                <XCircle className="w-6 h-6 text-brand-400 shrink-0 mt-0.5" data-id="element-88" data-mp="1754ldapxhgsm" />
                <span className="text-slate-300 text-lg" data-id="element-89" data-mp="12731woolbfgm">{item}</span>
              </li>)}
          </ul>
        </Card>

        <h3 className="text-2xl md:text-3xl font-bold text-center text-ink" data-id="element-90" data-mp="1guo66lx7bkq4">
          ¿Y si esta fuera la última semana que improvisás tus comidas?
        </h3>
      </div>
    </section>;
}